import API, { handleRequest } from '@/api/lib/api'

export const createReservation = data =>
  handleRequest(() => API.post(`restaurant/reservations`, data))

export const getReservations = (
  restaurant_id,
  page = 1,
  limit = 10,
  start_date = null,
  end_date = null,
  status = null,
  reservation_type = null,
  start_time = null,
  search = null
) => {
  const params = {
    page,
    per_page: limit
  }

  const isValid = v => v != null && String(v).trim() !== ''

  if (isValid(status)) params.status = status
  if (isValid(start_date)) params.start_date = start_date
  if (isValid(end_date)) params.end_date = end_date
  if (isValid(reservation_type)) params.reservation_type = reservation_type
  if (isValid(search)) params.search = search
  if (isValid(start_time)) params.start_time = start_time

  return handleRequest(() =>
    API.get(`restaurant/${restaurant_id}/reservations`, { params })
  )
}

export const getReservationById = reservation_id =>
  handleRequest(() => API.get(`restaurant/reservations/${reservation_id}`))

export const updateReservation = (reservation_id, data) =>
  handleRequest(() =>
    API.put(`restaurant/reservations/${reservation_id}`, data)
  )

export const deleteReservation = reservation_id =>
  handleRequest(() => API.delete(`restaurant/reservations/${reservation_id}`))

export const assignTableToReservation = (reservation_id, data) =>
  handleRequest(() =>
    API.post(`restaurant/reservations/${reservation_id}/assign-table`, data)
  )

export const acceptReservation = reservation_id =>
  handleRequest(() =>
    API.put(`restaurant/reservations/${reservation_id}/accept`)
  )

export const rejectReservation = (reservation_id, data) =>
  handleRequest(() =>
    API.put(`restaurant/reservations/${reservation_id}/reject`, data)
  )

export const markDepositPaid = reservation_id =>
  handleRequest(() =>
    API.put(`restaurant/reservations/${reservation_id}/mark-deposit-paid`)
  )

export const sendDepositLink = (reservation_id, channel) =>
  handleRequest(() =>
    API.post(`restaurant/reservations/${reservation_id}/send-deposit-link`, { channel })
  )

export const cancelDepositLink = reservation_id =>
  handleRequest(() =>
    API.post(`restaurant/reservations/${reservation_id}/cancel-deposit-link`)
  )

export const rejectAndRefundDeposit = reservation_id =>
  handleRequest(() =>
    API.post(`restaurant/reservations/${reservation_id}/reject-and-refund-deposit`)
  )

export const terminalPaymentReservation = reservation_id =>
  handleRequest(() =>
    API.post(`restaurant/reservations/${reservation_id}/terminal-payment`)
  )


